import { useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import { IllustrationSlot } from '../components/IllustrationSlot'
import { RESORTS, resortById } from '../data/resorts'
import { formatMoney } from '../lib/roi'
import { useStore } from '../lib/state'

export function Days() {
  const { state, addDay, removeDay, metrics } = useStore()
  const [resortId, setResortId] = useState(RESORTS[0]?.id ?? '')
  const [date, setDate] = useState(() => new Date().toISOString().slice(0, 10))
  const [toast, setToast] = useState<string | null>(null)

  const sorted = useMemo(
    () => [...state.days].sort((a, b) => b.date.localeCompare(a.date)),
    [state.days],
  )

  return (
    <div className="stack">
      <div className="status-hero" style={{ paddingBottom: 22 }}>
        <IllustrationSlot kind="snowflake" className="illus-hero" caption="art soon" />
        <div className="status-kicker">
          <span className="season-tag">Live ROI</span>
        </div>
        <div className="status-label">Cost per day</div>
        <div className={`status-value${metrics.cpd ? '' : ' empty'}`}>
          {metrics.cpd ? formatMoney(metrics.cpd) : '—'}
        </div>
        <div className="status-sub">
          {metrics.passPrice > 0 ? (
            <span>
              {formatMoney(metrics.passPrice)} pass ÷ {metrics.days} day
              {metrics.days === 1 ? '' : 's'}
            </span>
          ) : (
            <span>
              <Link to="/" style={{ color: 'var(--accent)', fontWeight: 700 }}>
                Pick a pass
              </Link>{' '}
              on Home to track value
            </span>
          )}
        </div>
      </div>

      <div className="card stack create-panel">
        <div className="page-head">
          <h2>Log a ski day</h2>
          <p className="muted">Each day drops your cost-per-day. Stamps the mountain as visited too.</p>
        </div>
        <div className="row" style={{ alignItems: 'end' }}>
          <div className="field" style={{ flex: 1, minWidth: 180 }}>
            <label>Mountain</label>
            <select value={resortId} onChange={(e) => setResortId(e.target.value)}>
              {RESORTS.map((r) => (
                <option key={r.id} value={r.id}>
                  {r.name} ({r.state})
                </option>
              ))}
            </select>
          </div>
          <div className="field">
            <label>Date</label>
            <input type="date" value={date} onChange={(e) => setDate(e.target.value)} />
          </div>
          <button
            className="btn primary lg"
            onClick={() => {
              if (!resortId || !date) return
              addDay(resortId, date)
              setToast('Day logged')
              setTimeout(() => setToast(null), 1600)
            }}
          >
            Log day
          </button>
        </div>
      </div>

      <div className="card stack">
        <h3 style={{ margin: 0 }}>Log</h3>
        {sorted.length === 0 ? (
          <div className="empty">No ski days logged yet.</div>
        ) : (
          <div className="list">
            {sorted.map((d) => (
              <div className="list-item" key={d.id}>
                <div className="row" style={{ gap: 12 }}>
                  <span className="day-item-dot" />
                  <div>
                    <div style={{ fontWeight: 700 }}>{resortById(d.resortId)?.name ?? d.resortId}</div>
                    <div className="muted" style={{ fontSize: 12 }}>
                      {d.date}
                    </div>
                  </div>
                </div>
                <button className="btn sm danger" onClick={() => removeDay(d.id)}>
                  Remove
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
      {toast && <div className="toast">{toast}</div>}
    </div>
  )
}
